// ISO 4217 fraction digits for currencies that differ from the default of 2
const CURRENCY_FRACTION_DIGITS: Record<string, number> = {
  // Zero-decimal currencies
  BIF: 0,
  CLP: 0,
  DJF: 0,
  GNF: 0,
  ISK: 0,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  PYG: 0,
  RWF: 0,
  UGX: 0,
  UYI: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  // Three-decimal currencies
  BHD: 3,
  IQD: 3,
  JOD: 3,
  KWD: 3,
  LYD: 3,
  OMR: 3,
  TND: 3,
};

export const getFractionDigits = (currency: string): number =>
  CURRENCY_FRACTION_DIGITS[currency.toUpperCase()] ?? 2;

export const toMajorUnits = (amountInMinorUnits: number, currency: string): number =>
  amountInMinorUnits / 10 ** getFractionDigits(currency);

export const toMinorUnits = (amount: number, currency: string): number =>
  Math.round(amount * 10 ** getFractionDigits(currency));

export const formatCurrency = (
  amount: number,
  currency: string,
  locale = "en",
  onlyValue = false,
  useGrouping = true,
): string => {
  const fractionDigits = getFractionDigits(currency);
  const value = toMajorUnits(amount, currency);

  if (onlyValue) {
    // Return clean numeric string for input fields
    return value.toFixed(fractionDigits);
  } else {
    // Format with currency symbol
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      useGrouping,
    }).format(value);
  }
};
